import { useState } from 'react'
import { ChevronDown } from '@styled-icons/heroicons-outline/ChevronDown'
import { ChevronUp } from '@styled-icons/heroicons-outline/ChevronUp'

const Collapsible = ({ title, children, className, right_side }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className={className}>
      <div
        className="row no-wrap align-cross-center pointer"
        onClick={() => setOpen(!open)}>
        {open ? (
          <ChevronUp className="icon-b" />
        ) : (
          <ChevronDown className="icon-b" />
        )}
        <h3 className="card-heading">{title}</h3>
        {right_side}
      </div>
      {open && (
        <div className="m-v">
          <div className="card-divider m-d" />
          {children}
        </div>
      )}
    </div>
  )
}
export default Collapsible
